// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table .ant-table-thead > tr > th {
  text-align: center; 
  font-size: 8px !important; 
}

.custom-table-header th {
  font-size: 8px !important; 
  font-weight: bold; 
}
:where(.css-dev-only-do-not-override-1cpbv2u).ant-table-wrapper .ant-table {
  font-size: 12px !important; 
}

.container {
  overflow-y: scroll; 

  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}


.container::-webkit-scrollbar {
  display: none; 
}
:where(.css-dev-only-do-not-override-1cpbv2u).ant-input {
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: thin; 

  &::-webkit-scrollbar {
    width: 1px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; 
    border-radius: 10px; 
    border: 2px solid #f1f1f1; 
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  &:focus {
    outline: none; /* Remove default focus outline */
    border: 2px solid #40a9ff; /* Add a focus border color */
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2); /* Optional shadow on focus */
  }

  /* Custom scrollbar styling on focus */
  &:focus::-webkit-scrollbar-thumb {
    background-color: #40a9ff; /* Change scrollbar color on focus */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Organization/FollowUpLeads/FollowUpLeads.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;;EAElB,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;AACvB;;;AAGA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;;EAErB;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa,EAAE,iCAAiC;IAChD,yBAAyB,EAAE,6BAA6B;IACxD,6CAA6C,EAAE,6BAA6B;EAC9E;;EAEA,sCAAsC;EACtC;IACE,yBAAyB,EAAE,oCAAoC;EACjE;AACF","sourcesContent":[".custom-table .ant-table-thead > tr > th {\n  text-align: center; \n  font-size: 8px !important; \n}\n\n.custom-table-header th {\n  font-size: 8px !important; \n  font-weight: bold; \n}\n:where(.css-dev-only-do-not-override-1cpbv2u).ant-table-wrapper .ant-table {\n  font-size: 12px !important; \n}\n\n.container {\n  overflow-y: scroll; \n\n  -ms-overflow-style: none;\n  overflow: -moz-scrollbars-none;\n  scrollbar-width: none;\n}\n\n\n.container::-webkit-scrollbar {\n  display: none; \n}\n:where(.css-dev-only-do-not-override-1cpbv2u).ant-input {\n  overflow-y: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: thin; \n\n  &::-webkit-scrollbar {\n    width: 1px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; \n    border-radius: 10px; \n    border: 2px solid #f1f1f1; \n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n  &:focus {\n    outline: none; /* Remove default focus outline */\n    border: 2px solid #40a9ff; /* Add a focus border color */\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2); /* Optional shadow on focus */\n  }\n\n  /* Custom scrollbar styling on focus */\n  &:focus::-webkit-scrollbar-thumb {\n    background-color: #40a9ff; /* Change scrollbar color on focus */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
